/**
 * MyCopro - Impersonation Banner
 * Bandeau affiché en haut de l'écran quand un admin est en mode impersonation
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, X, ArrowLeft } from 'lucide-react';
import { useAuthStore } from '@/stores';

export const ImpersonationBanner: React.FC = () => {
  const navigate = useNavigate();
  const { impersonation, stopImpersonation } = useAuthStore();

  if (!impersonation.isActive || !impersonation.targetUser) {
    return null;
  }

  const handleStop = async () => {
    await stopImpersonation();
    navigate('/admin/users');
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-amber-500 text-amber-950 px-4 py-2 shadow-lg safe-area-top">
      <div className="flex items-center justify-between max-w-screen-xl mx-auto">
        <div className="flex items-center gap-3">
          <Eye size={18} />
          <span className="font-medium text-sm">
            Mode visualisation : <strong>{impersonation.targetUser.name}</strong>
          </span>
          <span className="text-amber-800 text-xs hidden sm:inline">
            ({impersonation.targetUser.email})
          </span>
        </div>
        <button
          onClick={handleStop}
          className="flex items-center gap-2 px-3 py-1 bg-amber-600 hover:bg-amber-700 text-white rounded-lg text-sm font-medium transition-colors"
        >
          <ArrowLeft size={16} />
          <span>Quitter</span>
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
